import { useContext } from 'react'
import styled from 'styled-components'

import { GrowpIcon } from 'packages/components/GrowpIcon'

import { TagContextParam } from '../../utils/type'
import { TagContext } from '../../utils/util'

/**
 * 分类管理 - 头部
 *
 * @returns 组件
 */
export const TagDrawerHeader: React.FC = () => {
  const { current, setCurrent } = useContext<TagContextParam>(TagContext)

  return (
    <>
      {current === 0 ? (
        <Title>{'分类管理'}</Title>
      ) : (
        <DetailTitle onClick={() => setCurrent(0)}>
          <IconWrapper>
            <GrowpIcon
              name="Right"
              size={20}
            />
          </IconWrapper>
          <Title>{'分类详情'}</Title>
        </DetailTitle>
      )}
    </>
  )
}

const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
  height: 24px;
  line-height: 24px;
  color: ${(props) => props.theme.text._1};
`

const DetailTitle = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`
const IconWrapper = styled.div`
  cursor: pointer;
  margin-right: 12px;
`
